var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBmp314357(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    shapeRendering: "crispEdges",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v1h24v-1",
    fill: "#20242bff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 1v1h9v-1",
    fill: "#20242bff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 1v1h4v-1",
    fill: "#000000ff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13 1v1h11v-1",
    fill: "#20242bff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2v1h8v-1",
    fill: "#20242bff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 2v1h1v-1",
    fill: "#000000ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9 2v1h1v-1",
    fill: "#141414ff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10 2v1h1v-1",
    fill: "#1e1e1eff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 2v1h1v-1",
    fill: "#2b2b2bff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v1h1v-1",
    fill: "#1e1e1eff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13 2v1h1v-1",
    fill: "#000000ff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M14 2v1h10v-1",
    fill: "#20242bff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0 3v1h8v-1",
    fill: "#20242bff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v1h1v-1",
    fill: "#000000ff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3v1h1v-1",
    fill: "#141414ff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3v1h1v-1",
    fill: "#2b2b2bff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M11 3v1h1v-1",
    fill: "#1e1e1eff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12 3v1h1v-1",
    fill: "#2b2b2bff"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M13 3v1h1v-1",
    fill: "#000000ff"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3v1h10v-1",
    fill: "#20242bff"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4v1h7v-1",
    fill: "#20242bff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4v1h1v-1",
    fill: "#000000ff"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4v1h6v-1",
    fill: "#141414ff"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M14 4v1h1v-1",
    fill: "#000000ff"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4v1h9v-1",
    fill: "#20242bff"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 5v1h6v-1",
    fill: "#20242bff"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5v1h1v-1",
    fill: "#000000ff"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M7 5v1h2v-1",
    fill: "#1e1e1eff"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M9 5v1h1v-1",
    fill: "#2b2b2bff"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10 5v1h1v-1",
    fill: "#1e1e1eff"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5v1h1v-1",
    fill: "#2b2b2bff"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5v1h1v-1",
    fill: "#1e1e1eff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5v1h1v-1",
    fill: "#454545ff"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M14 5v1h1v-1",
    fill: "#1e1e1eff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5v1h1v-1",
    fill: "#000000ff"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5v1h8v-1",
    fill: "#20242bff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6v1h5v-1",
    fill: "#20242bff"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M5 6v1h1v-1",
    fill: "#000000ff"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6v1h2v-1",
    fill: "#141414ff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M8 6v1h1v-1",
    fill: "#2b2b2bff"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M9 6v1h1v-1",
    fill: "#1e1e1eff"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6v1h1v-1",
    fill: "#2b2b2bff"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6v1h1v-1",
    fill: "#1e1e1eff"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M12 6v1h1v-1",
    fill: "#2b2b2bff"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M13 6v1h1v-1",
    fill: "#1e1e1eff"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M14 6v1h1v-1",
    fill: "#454545ff"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6v1h1v-1",
    fill: "#2b2b2bff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6v1h1v-1",
    fill: "#000000ff"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M17 6v1h7v-1",
    fill: "#20242bff"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7v1h5v-1",
    fill: "#20242bff"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M5 7v1h1v-1",
    fill: "#000000ff"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7v1h1v-1",
    fill: "#141414ff"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7v1h9v-1",
    fill: "#1e1e1eff"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M16 7v1h1v-1",
    fill: "#2b2b2bff"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M17 7v1h1v-1",
    fill: "#000000ff"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M18 7v1h6v-1",
    fill: "#20242bff"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M0 8v1h5v-1",
    fill: "#20242bff"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8v1h1v-1",
    fill: "#000000ff"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M6 8v1h2v-1",
    fill: "#141414ff"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8v1h2v-1",
    fill: "#2b2b2bff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M10 8v1h1v-1",
    fill: "#1e1e1eff"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M11 8v1h1v-1",
    fill: "#2b2b2bff"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8v1h1v-1",
    fill: "#1e1e1eff"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13 8v1h1v-1",
    fill: "#2b2b2bff"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8v1h1v-1",
    fill: "#1e1e1eff"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8v1h1v-1",
    fill: "#2b2b2bff"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M16 8v1h1v-1",
    fill: "#1e1e1eff"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8v1h1v-1",
    fill: "#000000ff"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M18 8v1h6v-1",
    fill: "#20242bff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M0 9v1h5v-1",
    fill: "#20242bff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M5 9v1h1v-1",
    fill: "#000000ff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9v1h1v-1",
    fill: "#141414ff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9v1h2v-1",
    fill: "#1e1e1eff"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M9 9v1h3v-1",
    fill: "#defffdff"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9v1h1v-1",
    fill: "#2b2b2bff"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9v1h2v-1",
    fill: "#defffdff"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9v1h2v-1",
    fill: "#1e1e1eff"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9v1h1v-1",
    fill: "#000000ff"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M18 9v1h6v-1",
    fill: "#20242bff"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10v1h5v-1",
    fill: "#20242bff"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10v1h1v-1",
    fill: "#000000ff"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M6 10v1h2v-1",
    fill: "#141414ff"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10v1h8v-1",
    fill: "#defffdff"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10v1h1v-1",
    fill: "#1e1e1eff"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10v1h1v-1",
    fill: "#000000ff"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M18 10v1h6v-1",
    fill: "#20242bff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M0 11v1h5v-1",
    fill: "#20242bff"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M5 11v1h1v-1",
    fill: "#000000ff"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M6 11v1h1v-1",
    fill: "#141414ff"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M7 11v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11v1h1v-1",
    fill: "#defffdff"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11v1h2v-1",
    fill: "#3ad1c6ff"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11v1h3v-1",
    fill: "#defffdff"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11v1h2v-1",
    fill: "#3ad1c6ff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M16 11v1h1v-1",
    fill: "#000000ff"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M17 11v1h7v-1",
    fill: "#20242bff"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12v1h5v-1",
    fill: "#20242bff"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M5 12v1h1v-1",
    fill: "#000000ff"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M6 12v1h2v-1",
    fill: "#3ad1c6ff"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12v1h1v-1",
    fill: "#defffdff"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M9 12v1h1v-1",
    fill: "#2c91a4ff"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12v1h1v-1",
    fill: "#25f1b8ff"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12v1h3v-1",
    fill: "#defffdff"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12v1h1v-1",
    fill: "#2c91a4ff"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12v1h1v-1",
    fill: "#25f1b8ff"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12v1h1v-1",
    fill: "#000000ff"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M17 12v1h7v-1",
    fill: "#20242bff"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M0 13v1h5v-1",
    fill: "#20242bff"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M5 13v1h1v-1",
    fill: "#000000ff"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13v1h2v-1",
    fill: "#3ad1c6ff"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M8 13v1h8v-1",
    fill: "#defffdff"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M16 13v1h1v-1",
    fill: "#000000ff"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M17 13v1h7v-1",
    fill: "#20242bff"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M0 14v1h5v-1",
    fill: "#20242bff"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14v1h2v-1",
    fill: "#000000ff"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M7 14v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14v1h8v-1",
    fill: "#defffdff"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14v1h1v-1",
    fill: "#000000ff"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M17 14v1h7v-1",
    fill: "#20242bff"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15v1h6v-1",
    fill: "#20242bff"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M6 15v1h1v-1",
    fill: "#000000ff"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M7 15v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15v1h4v-1",
    fill: "#defffdff"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15v1h2v-1",
    fill: "#2c91a4ff"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M14 15v1h2v-1",
    fill: "#defffdff"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15v1h1v-1",
    fill: "#000000ff"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15v1h7v-1",
    fill: "#20242bff"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16v1h6v-1",
    fill: "#20242bff"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16v1h1v-1",
    fill: "#000000ff"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M7 16v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16v1h1v-1",
    fill: "#96dfdaff"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M9 16v1h7v-1",
    fill: "#defffdff"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16v1h1v-1",
    fill: "#000000ff"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16v1h1v-1",
    fill: "#5aa74bff"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16v1h1v-1",
    fill: "#20242bff"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16v1h1v-1",
    fill: "#dc4638ff"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16v1h4v-1",
    fill: "#20242bff"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17v1h6v-1",
    fill: "#20242bff"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M6 17v1h1v-1",
    fill: "#000000ff"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M7 17v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17v1h2v-1",
    fill: "#96dfdaff"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17v1h5v-1",
    fill: "#defffdff"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17v1h1v-1",
    fill: "#96dfdaff"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M16 17v1h1v-1",
    fill: "#5aa74bff"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M17 17v1h1v-1",
    fill: "#b33125ff"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17v1h1v-1",
    fill: "#dc4638ff"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M19 17v1h5v-1",
    fill: "#20242bff"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M0 18v1h6v-1",
    fill: "#20242bff"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M6 18v1h1v-1",
    fill: "#000000ff"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M7 18v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M8 18v1h3v-1",
    fill: "#96dfdaff"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M11 18v1h2v-1",
    fill: "#2c91a4ff"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M13 18v1h2v-1",
    fill: "#5aa74bff"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M15 18v1h2v-1",
    fill: "#489439ff"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18v1h1v-1",
    fill: "#b33125ff"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M18 18v1h1v-1",
    fill: "#ef7165ff"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M19 18v1h1v-1",
    fill: "#dc4638ff"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18v1h4v-1",
    fill: "#20242bff"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19v1h6v-1",
    fill: "#20242bff"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19v1h1v-1",
    fill: "#000000ff"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M7 19v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M8 19v1h3v-1",
    fill: "#96dfdaff"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M11 19v1h3v-1",
    fill: "#defffdff"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M14 19v1h2v-1",
    fill: "#96dfdaff"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19v1h1v-1",
    fill: "#489439ff"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M17 19v1h3v-1",
    fill: "#b33125ff"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M20 19v1h4v-1",
    fill: "#20242bff"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20v1h6v-1",
    fill: "#20242bff"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M6 20v1h1v-1",
    fill: "#000000ff"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M7 20v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M8 20v1h2v-1",
    fill: "#defffdff"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M10 20v1h5v-1",
    fill: "#96dfdaff"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M15 20v1h1v-1",
    fill: "#000000ff"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M16 20v1h1v-1",
    fill: "#20242bff"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M17 20v1h1v-1",
    fill: "#5aa74bff"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20v1h6v-1",
    fill: "#20242bff"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M0 21v1h6v-1",
    fill: "#20242bff"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M6 21v1h1v-1",
    fill: "#000000ff"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M7 21v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21v1h2v-1",
    fill: "#defffdff"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M10 21v1h5v-1",
    fill: "#000000ff"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M15 21v1h9v-1",
    fill: "#20242bff"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M0 22v1h6v-1",
    fill: "#20242bff"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22v1h1v-1",
    fill: "#000000ff"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M7 22v1h1v-1",
    fill: "#defffdff"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M8 22v1h2v-1",
    fill: "#96dfdaff"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22v1h1v-1",
    fill: "#000000ff"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22v1h13v-1",
    fill: "#20242bff"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M0 23v1h6v-1",
    fill: "#20242bff"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M6 23v1h1v-1",
    fill: "#000000ff"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M7 23v1h1v-1",
    fill: "#3ad1c6ff"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23v1h2v-1",
    fill: "#defffdff"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M10 23v1h1v-1",
    fill: "#000000ff"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M11 23v1h13v-1",
    fill: "#20242bff"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBmp314357);
export default __webpack_public_path__ + "static/media/bmp314357.4b4fc9a99553de50eb0f0b84144239e6.svg";
export { ForwardRef as ReactComponent };